<!--界面总容器-->
<template>
  <div class="easy-page">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { usePopupContainer } from './popup/PopupContainer';

// 通知popup更新header\footer slot
usePopupContainer();
</script>

<style lang="scss" scoped>
.easy-page {
  --easy-page-padding-x: var(--ext-easy-page-padding-x, 0);
  --easy-page-padding-y: var(--ext-easy-page-padding-y, 0);

  padding: 0;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--easy-page-background-color, #f5f5f5);
  overflow-y: auto;
  text-align: left;

  :deep(.page-block) {
    padding: 16px;
  }

  :deep(.hflow) {
    display: flex;
    flex-grow: 1;
  }

  :deep(.vflow) {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
}

.easy-drawer .easy-page {
  background-color: white;
}
</style>
